
import React, { useRef } from 'react';

import { useCarContext } from '../components/Context/CarContext';
import { useSnackbar } from './SnackBar';
import { useProgressBar } from './ProgressBar';

const BodyForm = () => {
    const { AddBody } = useCarContext();
    const { showSnackbar } = useSnackbar();
    const { showProgress } = useProgressBar();
    const bodyRef = useRef(null);
    const formRef=useRef([]);
    const handleClick=()=>{
        const elements=formRef.current.elements;
        for(let element of elements){
            if(element.tagName==='INPUT' && element.type!='BUTTON'){
                if(element.value===""){
                        element.style.borderColor='red';
                }else{
                    element.style.BorderColor='';
                }   
            }
        }

   }
   const emptyFieldCheck=(e)=>{
        if(e.target.value===""){
            e.target.style.borderColor='';
        }else{
            e.target.style.borderColor='';
        }
}

    const handleAddBody = async () => {
        if (bodyRef.current.value.trim() === '' ) {
            showSnackbar('Body Name cannot be blank', 'error');
            handleClick();
            return;
        }
        showProgress(true);
        await AddBody({ id: 0, name: bodyRef.current.value.trim() });
        showProgress(false);
        showSnackbar('This is a test message', 'warning');
    };

    return (

        <form ref={formRef}>
            <div className="row mb-3">
                <label htmlFor="icon" className="col-sm-2 col-form-label">Body Type </label>
                <div className="col-sm-10">
                    <input type="text" ref={bodyRef}  className="form-control" onBlur={(e)=>{ emptyFieldCheck(e); }}/>
                </div>
            </div>

            <div className="text-left">
                <label htmlFor="icon" className="col-sm-2 col-form-label"></label>
                <button type="button" onClick={handleAddBody} className="btn btn-primary blue-button">Save</button>

            </div>

        </form>


    );
};

export default BodyForm;
